/**
 * Central query key registry.
 *
 * Keys live here rather than inline so invalidation after a mutation cannot
 * silently miss a cache entry because two call sites spelled the key
 * differently.
 */
export const queryKeys = {
  config: ['config'] as const,
  me: ['me'] as const,
  usage: ['usage'] as const,
  analyses: ['analyses'] as const,
  archivedAnalyses: ['analyses', 'archived'] as const,
  analysis: (id: string) => ['analysis', id] as const,
  statements: ['statements'] as const,
  plans: ['plans'] as const,
}
